"use strict";

exports.__esModule = true;
exports.resetWithDefaultTemplate = exports.deleteBlock = exports.changeBlockEntityData = exports.addTextEntity = exports.addText = exports.addBlock = void 0;

var _draftJs = require("draft-js");

var _EmailDefaultTemplate = _interopRequireDefault(require("./../templates/EmailDefaultTemplate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var addBlock = function addBlock(editorState, blockType, data) {
  var contentState = editorState.getCurrentContent();
  var contentStateWithEntity = contentState.createEntity(blockType, 'IMMUTABLE', data);
  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();

  var newEditorState = _draftJs.AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');

  return _draftJs.EditorState.forceSelection(newEditorState, newEditorState.getCurrentContent().getSelectionAfter());
};

exports.addBlock = addBlock;

var addText = function addText(editorState, textToInsert) {
  var selection = editorState.getSelection();
  var contentState = editorState.getCurrentContent();

  var nextContentState = _draftJs.Modifier.insertText(contentState, selection, textToInsert);

  var nextEditorState = _draftJs.EditorState.push(editorState, nextContentState, 'insert-characters');

  return _draftJs.EditorState.forceSelection(nextEditorState, nextEditorState.getCurrentContent().getSelectionAfter());
};

exports.addText = addText;

var addTextEntity = function addTextEntity(editorState, textToInsert, blockType, data) {
  var selection = editorState.getSelection();
  var contentState = editorState.getCurrentContent();
  var contentStateWithEntity = contentState.createEntity(blockType, 'IMMUTABLE', data);
  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();

  var nextContentState = _draftJs.Modifier.insertText(contentState, selection, textToInsert, null, entityKey);

  nextContentState = _draftJs.Modifier.insertText( //add space
  nextContentState, nextContentState.getSelectionAfter(), ' ');

  var nextEditorState = _draftJs.EditorState.push(editorState, nextContentState, 'insert-' + blockType);

  return _draftJs.EditorState.forceSelection(nextEditorState, nextContentState.getSelectionAfter());
};

exports.addTextEntity = addTextEntity;

var deleteBlock = function deleteBlock(contentState, editorState, blockKey) {
  var newSelection = new _draftJs.SelectionState({
    anchorKey: blockKey,
    anchorOffset: 0,
    focusKey: blockKey,
    focusOffset: 0
  });
  var afterKey = contentState.getKeyAfter(blockKey);
  var afterBlock = contentState.getBlockForKey(afterKey);
  var targetRange; // Only if the following block the last with no text then the whole block
  // should be removed. Otherwise the block should be reduced to an unstyled block
  // without any characters.

  if (afterBlock && afterBlock.getType() === 'unstyled' && afterBlock.getLength() === 0 && afterBlock === contentState.getBlockMap().last()) {
    targetRange = new _draftJs.SelectionState({
      anchorKey: blockKey,
      anchorOffset: 0,
      focusKey: afterKey,
      focusOffset: 0
    });
  } else {
    targetRange = new _draftJs.SelectionState({
      anchorKey: blockKey,
      anchorOffset: 0,
      focusKey: blockKey,
      focusOffset: 1
    });
  } // change the blocktype and remove the characterList entry with the sticker


  var newContentState = _draftJs.Modifier.setBlockType(contentState, targetRange, 'unstyled');

  newContentState = _draftJs.Modifier.removeRange(newContentState, targetRange, 'backward'); // force to new selection

  var newState = _draftJs.EditorState.push(editorState, newContentState, 'remove-range');

  return _draftJs.EditorState.forceSelection(newState, newSelection);
};

exports.deleteBlock = deleteBlock;

var changeBlockEntityData = function changeBlockEntityData(editorState, blockEntityKey) {
  var contentState = editorState.getCurrentContent();

  for (var _len = arguments.length, data = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    data[_key - 2] = arguments[_key];
  }

  var newContentState = contentState.mergeEntityData.apply(contentState, [blockEntityKey].concat(data));
  return _draftJs.EditorState.push(editorState, newContentState, 'change-block-data');
};

exports.changeBlockEntityData = changeBlockEntityData;

var moveSelectionToStart = function moveSelectionToStart(editorState) {
  var content = editorState.getCurrentContent();
  var firstBlock = content.getFirstBlock();
  var firstKey = firstBlock.getKey();
  var length = firstBlock.getLength();
  return _draftJs.EditorState.acceptSelection(editorState, new _draftJs.SelectionState({
    anchorKey: firstKey,
    anchorOffset: length,
    focusKey: firstKey,
    focusOffset: length,
    isBackward: false
  }));
};

var resetWithDefaultTemplate = function resetWithDefaultTemplate(metadata) {
  var contentState = (0, _draftJs.convertFromRaw)((0, _EmailDefaultTemplate["default"])(metadata));

  var editorState = _draftJs.EditorState.createWithContent(contentState);

  var afterSelectionMove = moveSelectionToStart(editorState);
  return _draftJs.EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
};

exports.resetWithDefaultTemplate = resetWithDefaultTemplate;